export type Faq = {
  q: string
  a: string
}

export const crmPageFaqs: Faq[] = [
  {
    q: 'What is 1Dash.Pro?',
    a: 'Your own customer database, Powered by HighLevel — one place where every lead, customer and job lives. Included on every plan.',
  },
  {
    q: 'Can I see where every lead stands?',
    a: 'Yes. A pipeline view shows what stage every lead or job is in, so you know who needs a follow-up.',
  },
  {
    q: 'Do I get a full history on each customer?',
    a: 'Yes. Every call, text, email and note is saved on the contact, so anyone on your team can pick up where it left off.',
  },
  { q: 'Can customers book online?', a: 'Yes. An online booking calendar is included on every plan.' },
  { q: 'Can I send estimates and invoices and get paid by text?', a: 'Yes, on Autopilot.' },
  { q: 'Is there a mobile app?', a: 'Yes, on every plan, so your team can work from the job site.' },
  { q: 'How many team members can use it?', a: 'Launch 3, Pilot 5, Co-Pilot 10, Autopilot 20.' },
  {
    q: 'Do you build the automations for me?',
    a: 'Yes. Pipelines and automation are built for you on Autopilot.',
  },
]

export const pricingPageFaqs: Faq[] = [
  {
    q: 'What does "included usage" cover?',
    a: 'A monthly allowance for calls, texts, WhatsApp and AI inside your account: Launch $5, Pilot $15, Co-Pilot $30, Autopilot $60.',
  },
  { q: 'Does unused usage roll over?', a: 'No. It resets every month.' },
  { q: 'What if I go over?', a: 'Usage beyond your allowance is billed separately.' },
  {
    q: "What's billed separately?",
    a: 'Extra usage, domains, migrations, custom automation builds, voice clone setup, and work outside your package are quoted separately.',
  },
  {
    q: 'Can I pay by ACH or check?',
    a: 'Yes. Prices shown are card prices. Email results@getadroi.com for ACH or check pricing.',
  },
]
